module.exports = "https://files.cnvos.si/static/images/doodle_impact4values.png?12d726adaddb80331b88ff5080950b71";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodle_impact4values.png
// module id = 118
// module chunks = 1 2